import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TerminalService {

    constructor(protected http: HttpClient, private auth: AuthService) {
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getTerminals(type = null) {
        let url = environment.amenaEndpoint + 'terminals';

        if (type != null) {
            url += '?type=' + type;
        }

        console.log(url);

        return this.http.get(url, {headers: this.getHeaders()});
    }
}
